var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawFocusedDevGqoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 648.149,
    viewBox: "0 0 960 648.149",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-474.474 -232.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.258,639.776h0a260.207,260.207,0,0,1-2.183-56.405l2.183-31.156h0c-12.031,23.939-9.312,55.447,0,87.561Z",
    transform: "translate(390.764 107.389)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.089,643.334h0a191.276,191.276,0,0,1-1.051-33.574l1.051-18.545h0C851.3,605.464,852.608,624.219,857.089,643.334Z",
    transform: "translate(391.315 109.043)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.582,663.345v10.424a3.143,3.143,0,0,1-3.127,3.127h-5.212a1.039,1.039,0,0,0-1.042,1.042v85.476a3.143,3.143,0,0,1-3.127,3.127H824.487a3.13,3.13,0,0,1-3.127-3.127V677.938a1.046,1.046,0,0,0-1.042-1.042h-6.254a3.13,3.13,0,0,1-3.127-3.127V663.345a3.123,3.123,0,0,1,3.127-3.127h83.391a3.136,3.136,0,0,1,3.127,3.127Z",
    transform: "translate(389.523 111.968)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.84,
    height: 3.127,
    transform: "translate(1210.976 791.052)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.819,723.594c-23.37,9.671-47,9.778-70.883,0V701.563a111.317,111.317,0,0,1,70.883,0Z",
    transform: "translate(389.904 113.475)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.939,
    cy: 37.939,
    r: 37.939,
    transform: "translate(907.155 417.571)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.3,314.631a37.944,37.944,0,0,1,33.4,55.944A37.93,37.93,0,1,0,547.68,328.9,37.845,37.845,0,0,1,577.3,314.631Z",
    transform: "translate(378.363 103.984)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.444,
    cy: 111.444,
    r: 111.444,
    transform: "translate(762.755 232.54)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,178.2a111.425,111.425,0,0,1,154.448-11.685c-.911-.866-1.813-1.74-2.76-2.581A111.444,111.444,0,1,0,419.01,330.511c.947.842,1.92,1.635,2.887,2.439A111.425,111.425,0,0,1,415.41,178.2Z",
    transform: "translate(371.324 96.642)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.746,4.481,65.351,0,68.73,69.84-3.665,63.03Z",
    transform: "translate(839.703 423.782)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.778,
    cy: 71.778,
    r: 71.778,
    transform: "translate(801.478 310.929)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.162,378.544H464.726s5.887,31.669-35.668,35.447-79.333-7.556-94.444,20.778-8.6,129.221-8.6,129.221,28.333,102,51,117.111,221-5.667,221-5.667l83-104.806L678.208,489.8c-1.468-42.207-40-73.9-81.508-66.086q-1.223.23-2.462.5s-9.118-6.815-34.136-19.323C544.8,397.239,540.162,378.544,540.162,378.544Z",
    transform: "translate(368.908 100.027)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,410.942s18.256,33.125,10.7,80.347,24.146,147.1,24.146,147.1l22.667-5.667S414.663,534.5,418.44,511.83s4.82-89.554-14.069-100.888S372.26,410.942,372.26,410.942Z",
    transform: "translate(370.927 101.187)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582,427.844l7.94,209.13,15.111,9.444s21.722-229.5,10.389-229.5h-23.06a10.393,10.393,0,0,0-10.393,10.393Q581.986,427.578,582,427.844Z",
    transform: "translate(379.818 101.654)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.444,
    cy: 9.444,
    r: 9.444,
    transform: "translate(778.979 715.962)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.444,
    cy: 9.444,
    r: 9.444,
    transform: "translate(967.868 725.406)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.672,58.069v71.778H340.3L361.45,107.18l-2.833,22.667h73.477l-4.533-22.667,9.067,22.667h11.711V58.069Z",
    transform: "translate(488.194 234.915)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.667,
    cy: 10.389,
    rx: 5.667,
    ry: 10.389,
    transform: "translate(794.866 357.207)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.667,
    cy: 10.389,
    rx: 5.667,
    ry: 10.389,
    transform: "translate(940.311 357.207)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.694,744.969V751.3a13.9,13.9,0,0,1-.948,5.076,14.263,14.263,0,0,1-1.011,2.085,14.007,14.007,0,0,1-12.04,6.838H258.215a14.007,14.007,0,0,1-12.04-6.838,14.269,14.269,0,0,1-1.011-2.085,13.906,13.906,0,0,1-.949-5.076v-6.327a14,14,0,0,1,13.992-14h26.839v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.746v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.756v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.746v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.746v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.756v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.746v-2.95a.583.583,0,0,1,.582-.584H538.785a.583.583,0,0,1,.584.582v2.952h8.756v-2.95a.583.583,0,0,1,.582-.584h14a.59.59,0,0,1,.584.584v2.95h8.746v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.746v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h8.756v-2.95a.583.583,0,0,1,.582-.584h14a.581.581,0,0,1,.573.584v2.95h8.756v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952H667.7v-2.95a.583.583,0,0,1,.582-.584h14a.583.583,0,0,1,.584.582v2.952h40.83a14,14,0,0,1,14,13.992Z",
    transform: "translate(365.5 114.817)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 902.764,
    height: 2.085,
    transform: "translate(474.474 878.481)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.485,488.621H273.1a11.736,11.736,0,0,0-11.736,11.736V737.93A11.736,11.736,0,0,0,273.1,749.666H699.485a11.736,11.736,0,0,0,11.736-11.736V500.357A11.736,11.736,0,0,0,699.485,488.621Z",
    transform: "translate(366.227 104.694)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.06,
    cy: 26.06,
    r: 26.06,
    transform: "translate(826.802 650.198)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.823,272.7,649.379,140.1h62.109v-2.085H648.509l-.305.31L516.341,271.23Z",
    transform: "translate(495.512 230.519)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.422,
    height: 16.678,
    rx: 8,
    transform: "translate(1280.723 313.628)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.382,247.272H842.026V213.915h33.357Zm-31.2-2.155h29.046V216.07H844.181Z",
    transform: "translate(389.991 93.049)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.422,
    height: 16.678,
    rx: 8,
    transform: "translate(1280.723 362.335)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.382,290.7H842.026V257.348h33.357Zm-31.2-2.155h29.046V259.5H844.181Z",
    transform: "translate(389.991 94.509)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152.422,
    height: 16.678,
    rx: 8,
    transform: "translate(1282.052 407.609)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.382,334.137H842.026V300.781h33.357Zm-31.2-2.155h29.046V302.936H844.181Z",
    transform: "translate(389.991 96.731)",
    fill: "#3f3d56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawFocusedDevGqoa);
export default __webpack_public_path__ + "static/media/undraw_focused-dev_gqoa.c328cf1da62a31c3cdde5d98939e4f7d.svg";
export { ForwardRef as ReactComponent };